module.exports = __webpack_public_path__ + "static/media/dissectDetail2.32f92ca9.jpeg";